'use es6';

import http from 'developer-docs-shared-components/lib/utils/httpClient';
const API_CATALOG_TOPICS = 'api-catalog-public/v1/apis';
export function fetch() {
  return http.get(API_CATALOG_TOPICS);
}